import { SnowplowService } from 'wanderu-service-analytics';

function tripDetailsExpanded({ tripId }) {
    SnowplowService.fireStructuredEventWithBatchId({
        category: 'react_tripsummary',
        action: 'click',
        label: 'change_trip',
        property: {
            trip_id: tripId,
        },
    });
}

export default {
    tripDetailsExpanded,
};
